import { __decorate } from "tslib";
import { LitElement, html, customElement } from 'lit-element';
let DemoKeyboard = class DemoKeyboard extends LitElement {
    render() {
        return html `
  <cds-grid>
    <cds-grid-column width="150" resizable="false">Key</cds-grid-column>
    <cds-grid-column>Function</cds-grid-column>
    <cds-grid-row>
      <cds-grid-cell>Right Arrow</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus one cell to the right.</li>
          <li>If focus is on the right-most cell in the row, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Left Arrow</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus one cell to the left.</li>
          <li>If focus is on the left-most cell in the row, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Down Arrow</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus one cell down.</li>
          <li>If focus is on the bottom cell in the column, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Up Arrow</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus one cell Up.</li>
          <li>If focus is on the top cell in the column, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Page Down</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus down five rows, scrolling so the bottom row in the currently visible set of rows becomes the first visible row.</li>
          <li>If focus is in the last row, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Page Up</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus up 5 rows, scrolling so the top row in the currently visible set of rows becomes the last visible row.</li>
          <li>If focus is in the first row of the grid, focus does not move.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Home</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus to the first cell in the row that contains focus.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>End</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus to the last cell in the row that contains focus.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Control + Home</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus to the first cell in the first row.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-row>
      <cds-grid-cell>Control + End</cds-grid-cell>
      <cds-grid-cell>
        <ul cds-list>
          <li>Moves focus to the last cell in the last row.</li>
        </ul>
      </cds-grid-cell>
    </cds-grid-row>
    <cds-grid-footer>
      <a cds-text="subsection link" href="https://www.w3.org/TR/wai-aria-practices/examples/grid/dataGrids.html#kbd_label">spec</a>
    </cds-grid-footer>
  </cds-grid>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
DemoKeyboard = __decorate([
    customElement('demo-keyboard')
], DemoKeyboard);
export { DemoKeyboard };
//# sourceMappingURL=demo.cell-keyboard.js.map